export const SET_ATTRIBUTES = 'SET_ATTRIBUTES'
export const ADD_ATTRIBUT = 'ADD_ATTRIBUT'
export const REMOVE_ATTRIBUT = 'REMOVE_ATTRIBUT'
